import { useAppDispatch } from "@lib/stores";
import { AuthActions } from "@lib/stores/auth/slices";
import { actions as PlaylistActions } from "@lib/stores/myLibrary/slices";
import { SettingActions } from "@lib/stores/settings/slices";
import { Alert, AlertDescription } from "@ui/alert";
import { CircleCheck } from "lucide-react";
import { useState, useEffect } from "react";

const SuccessAlert = ({ message }: { message: string }) => {
  const [isVisible, setIsVisible] = useState(true);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(AuthActions.resetSuccessAlert());
      dispatch(SettingActions.resetSuccessAlert());
      dispatch(PlaylistActions.resetSuccessAlert());
      setIsVisible(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, [dispatch]);

  if (!isVisible) return null;

  return (
    <Alert className="animate-in fade-in slide-in-from-top-5 fixed left-1/2 top-2 z-50 mx-auto w-fit -translate-x-1/2 bg-green-500 p-3 duration-300 [&>svg]:top-3">
      <CircleCheck className="my-auto h-5 w-5" color="white" />
      <AlertDescription className="me-5 text-[14px] text-white">
        {message}
      </AlertDescription>
    </Alert>
  );
};

export default SuccessAlert;
